import React from 'react'
import Link from 'gatsby-link'
import HeaderLogo from './HeaderLogo'
import SiteTitle from './SiteTitle'

const SiteBranding = ({ siteTitle }) => (
      <Link className="navbar-item" to="/">
        <HeaderLogo />
        <SiteTitle />
      </Link>
)

export default SiteBranding


// WEBPACK FOOTER //
// ./src/components/SiteBranding.js